import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api' });
const WAREHOUSE = 'NPD Warehouse -KFI';

export default function ProjectMaterialReport({ project }) {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const load = () => {
    const params = {};
    if (month) params.month = month;
    if (year) params.year = year;
    API.get(`/projects/${project.id}/material-report`, { params }).then(r => setData(r.data)).catch(e => console.error(e));
  };

  useEffect(() => { load(); }, [project.id]);

  const fmt = (n) => `AED ${(n||0).toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const printPDF = () => {
    if (!data) return;
    const today = new Date().toLocaleDateString('en-AE', { day: '2-digit', month: 'short', year: 'numeric' });
    const userName = (() => { try { const u = JSON.parse(localStorage.getItem('npd_user')); return u?.name || u?.username || ''; } catch { return ''; } })();

    const rows = data.materials.map((m, idx) => `
      <tr style="${idx%2===1?'background:#fdf9fc;':''}">
        <td style="font-family:'Courier New',monospace;font-size:9px;color:#7B2D6B;font-weight:600;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${m.item_code}</td>
        <td style="font-size:10px;font-weight:500;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${m.item_name||'—'}</td>
        <td style="text-align:center;font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${Number(m.total_quantity).toFixed(3)} ${m.unit||''}</td>
        <td style="text-align:right;font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">AED ${Number(m.avg_unit_cost||0).toFixed(3)}</td>
        <td style="text-align:right;font-weight:600;color:#7B2D6B;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">AED ${Number(m.total_cost||0).toLocaleString('en-AE',{minimumFractionDigits:2})}</td>
        <td style="text-align:center;font-size:10px;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${WAREHOUSE}</td>
        <td style="font-size:9px;color:#888;padding:5px 8px;border-bottom:0.5px solid #f5edf3;">${m.product_names||'—'}</td>
      </tr>`).join('');

    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
    <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
    <style>
      *{box-sizing:border-box;margin:0;padding:0;}
      body{font-family:'Inter',Arial,sans-serif;background:#fff;padding:28px;color:#1a1a1a;font-size:11px;}
      .top-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:2px 2px 0 0;}
      .bottom-bar{height:4px;background:linear-gradient(90deg,#7B2D6B 0%,#a03880 55%,#E8541A 100%);border-radius:0 0 2px 2px;margin-top:12px;}
      table{width:100%;border-collapse:collapse;}
      th{padding:5px 8px;text-align:left;font-size:7px;letter-spacing:0.1em;text-transform:uppercase;color:#c0a0b8;font-weight:600;border-bottom:1px solid #e4d4e0;}
      @media print{body{padding:16px;} @page{margin:0;size:A4 landscape;} body{padding:20px 28px;}}
    </style></head><body>
    <div class="top-bar"></div>
    <div style="padding:12px 0 10px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #f0e8ed;margin-bottom:12px;">
      <div>
        <div style="font-size:6.5px;letter-spacing:0.22em;text-transform:uppercase;color:#E8541A;margin-bottom:3px;">Project Material Consumption Report</div>
        <div style="font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#7B2D6B;">Kallada Food Industries LLC</div>
        <div style="font-size:8px;color:#c0a0b8;margin-top:1px;">Dubai, United Arab Emirates</div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:26px;font-weight:800;color:#7B2D6B;position:relative;display:inline-block;">BGH<span style="position:absolute;top:1px;right:-9px;width:7px;height:7px;background:#E8541A;border-radius:1.5px;display:inline-block;"></span></div>
        <div style="font-size:6px;letter-spacing:0.16em;text-transform:uppercase;color:#E8541A;font-weight:600;margin-top:3px;">Bettergrow Holding</div>
      </div>
    </div>
    <div style="background:#f9f3f8;border:1px solid #ede0ea;border-radius:3px;padding:8px 14px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:center;">
      <div style="font-size:14px;font-weight:700;color:#7B2D6B;">${data.project.name}</div>
      <div style="display:flex;gap:20px;">
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Code</div><div style="font-family:monospace;font-size:10px;font-weight:600;color:#555;">${data.project.project_code}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Warehouse</div><div style="font-size:10px;font-weight:600;color:#333;">${WAREHOUSE}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Total Items</div><div style="font-size:10px;font-weight:600;color:#7B2D6B;">${data.materials.length}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Total Cost</div><div style="font-size:10px;font-weight:700;color:#7B2D6B;">${fmt(data.grandTotal)}</div></div>
        <div><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.1em;">Report Date</div><div style="font-size:10px;font-weight:600;color:#333;">${today}</div></div>
      </div>
    </div>
    <table>
      <thead><tr>
        <th style="width:85px;">Item Code</th>
        <th>Item Name</th>
        <th style="width:90px;text-align:center;">Total Qty</th>
        <th style="width:90px;text-align:right;">Avg Rate</th>
        <th style="width:110px;text-align:right;">Total Cost</th>
        <th style="width:130px;text-align:center;">Warehouse</th>
        <th>Used In Products</th>
      </tr></thead>
      <tbody>
        ${rows}
        <tr style="background:#f9f3f8;">
          <td colspan="4" style="text-align:right;font-weight:700;color:#7B2D6B;font-size:9px;text-transform:uppercase;letter-spacing:0.06em;padding:6px 8px;border-top:1px solid #e4d4e0;">Grand Total</td>
          <td style="text-align:right;font-weight:700;color:#7B2D6B;font-size:12px;padding:6px 8px;border-top:1px solid #e4d4e0;">${fmt(data.grandTotal)}</td>
          <td colspan="2" style="border-top:1px solid #e4d4e0;"></td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top:14px;display:grid;grid-template-columns:1fr 1fr 1fr;border:1px solid #e4d4e0;border-radius:3px;overflow:hidden;">
      <div style="padding:8px 12px;border-right:1px solid #e4d4e0;"><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Prepared By</div><div style="font-size:10px;font-weight:600;color:#333;">${userName}</div></div>
      <div style="padding:8px 12px;border-right:1px solid #e4d4e0;"><div style="font-size:7px;color:#c0a0b8;text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Warehouse</div><div style="font-size:10px;font-weight:600;color:#333;">${WAREHOUSE}</div></div>
      <div style="padding:8px 12px;background:#7B2D6B;"><div style="font-size:7px;color:rgba(255,255,255,0.6);text-transform:uppercase;letter-spacing:0.14em;margin-bottom:3px;">Report Date</div><div style="font-size:10px;font-weight:700;color:#fff;">${today}</div></div>
    </div>
    <div style="margin-top:10px;text-align:center;">
      <span style="font-size:7px;color:#d0bfca;letter-spacing:0.07em;text-transform:uppercase;">Kallada Food Industries LLC · Confidential Document · ${today}</span>
    </div>
    <div class="bottom-bar"></div>
    </body></html>`);
    win.document.close();
    win.focus();
  };

  if (!data) return <div className="empty-state"><p>Loading...</p></div>;

  return (
    <div>
        <div className="card mb-4" style={{ padding: '12px 16px' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Month</label>
            <select value={month} onChange={e => setMonth(e.target.value)} style={{ width: 120 }}>
              <option value="">All Months</option>
              {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m,i) => (
                <option key={m} value={m}>{['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][i]}</option>
              ))}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Year</label>
            <select value={year} onChange={e => setYear(e.target.value)} style={{ width: 100 }}>
              <option value="">All Years</option>
              {['2024','2025','2026','2027'].map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <button className="btn btn-primary" onClick={load}>Apply Filter</button>
          <button className="btn btn-secondary" onClick={() => { setMonth(''); setYear(''); setTimeout(load, 50); }}>Clear</button>
          <div style={{ marginLeft: 'auto' }}>
            <button className="btn btn-primary" onClick={printPDF}>⬇ Download / Print PDF</button>
          </div>
        </div>
      </div>
      <div className="flex-between mb-4">
        <div className="text-muted" style={{ fontSize: 13 }}>{data.materials.length} materials · Warehouse: <span className="mono">{WAREHOUSE}</span></div>
      </div>

      {data.materials.length === 0 ? (
        <div className="empty-state card">
          <div className="empty-state-icon">◈</div>
          <p>No recipe ingredients found. Confirm recipes for products in this project first.</p>
        </div>
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0, border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
            <div style={{ padding: '14px 18px', borderRight: '1px solid var(--border)', background: 'var(--bg-surface)' }}>
              <div style={{ fontSize: 10, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 4 }}>Total Materials</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--accent)' }}>{data.materials.length} items</div>
            </div>
            <div style={{ padding: '14px 18px', background: 'var(--accent-dim)' }}>
              <div style={{ fontSize: 10, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 4 }}>Total Material Cost</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--accent)', fontFamily: 'DM Mono, monospace' }}>AED {data.grandTotal.toLocaleString('en-AE', { minimumFractionDigits: 2 })}</div>
            </div>
          </div>

          <div className="card">
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th className="text-right">Total Qty</th>
                    <th className="text-right">Avg Rate</th>
                    <th className="text-right">Total Cost</th>
                    <th>Warehouse</th>
                    <th>Used In</th>
                  </tr>
                </thead>
                <tbody>
                  {data.materials.map((m, idx) => (
                    <tr key={idx}>
                      <td className="mono" style={{ color: 'var(--accent)' }}>{m.item_code}</td>
                      <td style={{ fontWeight: 500 }}>{m.item_name}</td>
                      <td className="text-right mono">{Number(m.total_quantity).toFixed(3)} {m.unit}</td>
                      <td className="text-right mono">AED {Number(m.avg_unit_cost||0).toFixed(3)}</td>
                      <td className="text-right cost-value">AED {Number(m.total_cost||0).toLocaleString('en-AE', { minimumFractionDigits: 2 })}</td>
                      <td className="text-muted" style={{ fontSize: 11 }}>{WAREHOUSE}</td>
                      <td className="text-muted" style={{ fontSize: 11 }}>{m.product_names}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
